import keys from '../keys';

export default {
  [keys.ACTIVE_BUSINESSES]: 'Active Businesses',
  [keys.ACTIVITY_CREATE_SUCCESS]: 'Activity created successfully',
  [keys.ADD]: 'Add',
  [keys.ADD_ACTIVITY]: 'Add Activity',
  [keys.ADD_USER]: 'Add User',
  [keys.AGREE]: 'Agree',
  [keys.AGENT_DOCS_FETCH_ERROR]: 'Unable to fetch documents. Please try again.',
  [keys.AGENT_DOCS_GENERATE_ERROR]:
    'Unable to generate links. Please try again.',
  [keys.AGENT_DOCS_NO_DOCUMENTS]: 'No documents found.',
  [keys.AGENT_DOCS_NO_LINKS]: 'No report links found.',
  [keys.AGENT_DOCS_SELECT_ALL_FILTERS]: 'Please select all filters.',
  [keys.AGENT_DOCS_TITLE]: 'My Documents:',
  [keys.ALL_DAY]: 'All Day',
  [keys.ALL_FILTERS]: 'All Filters',
  [keys.ALL_SUBORDINATES]: 'All Subordinates',
  [keys.APP]: 'App',
  [keys.APPLY_FILTERS]: 'Apply Filters',
  [keys.ASK_ME_ANYTHING]: 'Ask me anything...',
  [keys.ASSIGNEES]: 'Assignees',
  [keys.AUDIT_HISTORY]: 'Audit History',
  [keys.AUTO_SAVED_AT]: 'Auto Saved at {{lastSaved}}',
  [keys.BACK]: 'Back',
  [keys.BROCHURES_VIDEOS]: 'Brochures/Videos',
  [keys.BUILD_IN_PROGRESS]: 'Build in progress',
  [keys.BUILD_IS_DONE]: 'Build is done',
  [keys.BUILD_IS_FAILED]: 'Build is failed. Please check the pr',
  [keys.BUTTON_CANCEL]: 'CANCEL',
  [keys.BUTTON_SAVE_AND_CONTINUE]: 'SAVE AND CONTINUE',
  [keys.CACHE_CLEAN]: 'Cache Clean',
  [keys.CANCEL]: 'Cancel',
  [keys.CHANGE_MANAGER]: 'Change Manager',
  [keys.CHECKLIST]: 'Checklist',
  [keys.CHECK_FOR_APPROVAL]: 'Check For Approval',
  [keys.CLEAN_CACHE]: 'Clean Cache',
  [keys.CLOSE_COPILOT]: 'Close Copilot',
  [keys.CODE]: 'Code',
  [keys.CODE_COVERAGE]: 'Code Coverage',
  [keys.COMING_SOON]: 'Coming Soon...',
  [keys.COMMIT_DONE_AT]: 'Commit Done at {{date}}',
  [keys.COMPLETED_APPLICATIONS]: 'Completed Applications ({{count}})',
  [keys.COMPONENT]: 'Component',
  [keys.COMPONENT_NOT_FOUND]: 'Component not found',
  [keys.CONDITION_EQUALS_EXAMPLE]:
    'For e.g. EQUALS(form>if_name>name,static>text>Test)',
  [keys.CONFIG_APPLIED_SUCCESSFULLY]: 'Config applied successfully',
  [keys.CONFIG_SHOULD_BE_AN_OBJECT]: 'Config should be an object.',
  [keys.CONFIRMATION_PROCEED_ACTION]: 'Are you sure you want to proceed ?',
  [keys.CONFIRM_ACTION_PROMPT]: 'Do you want to perform this action?',
  [keys.CONFIRM_CREATE_PATCH_BRANCH]:
    'Are you sure you want to create patch branch?',
  [keys.CONFIRM_CREATE_RELEASE_BRANCH]:
    'Are you sure you want to create release branch?',
  [keys.CONFIRM_MPIN]: 'Confirm MPIN',
  [keys.CONFIRM_PASSWORD]: 'Confirm Password',
  [keys.CONFIRM_SELECTION]: 'Confirm Selection ?',
  [keys.CONTACT_US]: 'Contact Us',
  [keys.COVERAGE]: 'Coverage',
  [keys.CREATE_FORM]: 'Create Form',
  [keys.CREATE_TASK]: 'Create Task',
  [keys.CREATE_NEW_APPLICATION]: 'Create New Application',
  [keys.CRON_DETAILS]: 'Cron Details',
  [keys.CURRENT]: 'Current:',
  [keys.CYPRESS_DASHBOARD]: 'Cypress Dashboard',
  [keys.CYPRESS_DASHBOARD_OPENED_IN_ANOTHER_TAB]:
    'Cypress Dashboard opened in another tab',
  [keys.CYPRESS_DELETE]: 'Cypress Delete',
  [keys.DATA_SYNC_CHECK_BACK_LATER]:
    'Please check back after some time to complete the sync.',
  [keys.DATA_SYNC_IN_PROGRESS]: 'Data Sync in Progress',
  [keys.DATA_SYNC_PROCESS_INITIATED]: 'We have Initiated the Data Sync Process',
  [keys.DEFAULT]: 'Default',
  [keys.DELETE_CYPRESS_RUNS]: 'Delete Cypress Runs',
  [keys.DELETE_PROJECT]: 'Delete Project',
  [keys.DESKTOP]: 'Desktop',
  [keys.DETAILS]: 'Details',
  [keys.DISABLE_USER]: 'Disable User',
  [keys.DISCARD]: 'Discard',
  [keys.DISCONNECTED_PLEASE_TRY_AGAIN]: 'Disconnected, please try again',
  [keys.DOCUMENT_PREVIEW]: 'Document preview',
  [keys.DONE]: 'Done',
  [keys.DOWNLOAD]: 'Download',
  [keys.DOWNLOAD_TEMPLATE]: 'Download Template',
  [keys.DYNAMIC]: 'Dynamic',
  [keys.E2E_INTEGRATION]: 'E2E Integration',
  [keys.EDIT]: 'Edit',
  [keys.EDIT_EXISTING_UI]: 'Edit Existing UI',
  [keys.EDIT_FORM]: 'Edit Form',
  [keys.EDIT_TASK]: 'Edit Task',
  [keys.EDIT_USER]: 'Edit User',
  [keys.EMAIL]: 'Email',
  [keys.ENABLE_USER]: 'Enable User',
  [keys.ENTER_PHONE_NUMBER]: 'Enter 10 digit phone number',
  [keys.ENTER_EMAIL]: 'Enter Email',
  [keys.ENTER_FEATURE_TILE_DESCRIPTION]: 'Enter the Feature Tile Description',
  [keys.ENTER_FEATURE_TILE_ICON]: 'Enter the Feature Tile Icon',
  [keys.ENTER_FEATURE_TILE_NAME]: 'Enter the Feature Tile Name',
  [keys.ENTER_JIRA_TICKET_ID]: 'Enter the Jira Ticket ID',
  [keys.ENTER_NUMBER]: 'Enter number',
  [keys.ENTER_PASSWORD]: 'Enter Password',
  [keys.ENTER_PROJECT_NAME]: 'Enter the Project name',
  [keys.ENTER_SAVE_QUERY]: 'Enter the Save Query',
  [keys.ENTER_SELFSERVE_CONFIG]: 'Enter the SelfServe config',
  [keys.ENTER_TEXT]: 'Enter text',
  [keys.ENTER_UI_QUERY]: 'Enter the Ui Query',
  [keys.ENTITIES]: 'Entities',
  [keys.ENTITY_LIST]: 'Entity List',
  [keys.ENTITY_DETAILS_NOT_FOUND]: 'Entity Details not found',
  [keys.ERROR_ARGUMENT_EMPTY_AT_TYPE]: 'Argument {{arg}} is empty at {{type}}',
  [keys.ERROR_FETCHING_CARD_DATA]: 'Error while fetching {{cardName}} data',
  [keys.ERROR_FETCHING_CARD_DETAILS]: 'Error fetching {{cardCode}} details',
  [keys.ERROR_FETCHING_CONFIG_DATA]: 'Error while fetching config data',
  [keys.ERROR_FETCHING_DETAILS_DATA]: 'Error while fetching details data',
  [keys.ERROR_FETCHING_FEATURE_CONFIG_DATA]:
    'Error while fetching feature config data',
  [keys.ERROR_FETCHING_GROUP_DATA]: 'Error occurred while fetching group data',
  [keys.ERROR_FETCHING_HEADER_DATA]:
    'Error occurred while fetching header data',
  [keys.ERROR_FETCHING_HEADER_DETAILS]: 'Error fetching header details',
  [keys.ERROR_FETCHING_LIST_DATA]: 'Error while fetching list data',
  [keys.ERROR_FETCHING_PROFILE_DATA]: 'Error while fetching profile data',
  [keys.ERROR_FETCH_GUEST_TOKEN_FAILED]:
    'Failed to fetch guest token. Error: {{error}}',
  [keys.ERROR_FIELDS_PROPERTY_INVALID]:
    'The "fields" property must exist and be an array.',
  [keys.ERROR_FUNCTION_ARGUMENTS_EXPECTED]:
    'The function {{id}} expects {{args}} arguments',
  [keys.ERROR_FUNCTION_INVALID]: 'Function {{id}} Not Valid',
  [keys.ERROR_GUEST_TOKEN_FETCH_FAILED]: 'Failed to fetch guest token',
  [keys.ERROR_INVALID_QUERY_NEAR_ID]: 'This is not a valid query near {{id}}',
  [keys.ERROR_INVALID_QUERY_LENGTH_NEAR_PARAM]:
    'This is not a valid query near {{param}}. Its length should be {{expectedLength}}',
  [keys.ERROR_LOGOUT_FAILED]: 'Error occurred while logging out',
  [keys.ERROR_SESSION_EXPIRED_LOGGED_OUT]:
    "Oh no! It looks like your session has expired due to inactivity. To keep your data secure, we've automatically logged you out.",
  [keys.ERROR_SUBMITTING_FORM]: 'Error while submitting form',
  [keys.EXPLORE_OTHER_BUSINESSES_PROMPT]:
    'While you wait, would you like to explore other businesses.',
  [keys.EXTRA_CHARACTERS_FOUND]: 'Extra Characters Found',
  [keys.FAILED_TO_CLEAR_HISTORY_TRY_AGAIN]:
    'Failed to clear history, try again',
  [keys.FAILED_TO_CONNECT_PLEASE_TRY_AGAIN]:
    'Failed to connect, please try again',
  [keys.FAILED_TO_FETCH_HISTORY]: 'Failed to fetch History',
  [keys.FAILED_TO_GENERATE_RESPONSE]:
    'Failed to generate a response, please try again or ask something else',
  [keys.FEATURES]: 'Features',
  [keys.FEATURE_BRANCH]: 'Feature Branch',
  [keys.FEATURE_CONFIGURATION_DESCRIPTION]:
    'This is the place where you configure your features configuration',
  [keys.FILTERS]: 'Filters',
  [keys.FORM_BUILDER]: 'Form Builder',
  [keys.FORM_CONFIG_DESCRIPTION]:
    'Form config will include two properties: `fields` and `formulaContext`. The `session` and `vo` namespaces must be explicitly defined inside `formulaContext`. The context configured here will also be utilized in the formula evaluation for the sample form.',
  [keys.FORMULA_FRAMEWORK]: 'Formula Framework',
  [keys.FRONTEND_EVOLVED]: 'Frontend Evolved',
  [keys.FRONTEND_WIKI]: 'Frontend Wiki',
  [keys.FIRST_CONVERSATION_PROMPTS]:
    'Here are a few prompts to start your first conversation',
  [keys.GENERIC_ERROR_MESSAGE]: 'Error: {{error}}',
  [keys.GENERIC_ERROR_TRY_AGAIN]:
    'Something went wrong. Please try again later',
  [keys.HELP_IF_UNKNOWN_NPN]: 'if you don`t know your NPN',
  [keys.HISTORY]: 'History',
  [keys.HOME]: 'Home',
  [keys.HORIZONTAL_LINE]: 'Horizontal Line',
  [keys.INCOMING_EMAIL]: 'Incoming Email',
  [keys.IN_PROGRESS]: 'In Progress:',
  [keys.INVALID_EMAIL]: 'Invalid Email',
  [keys.INVALID_JSON]: 'Invalid JSON.',
  [keys.KT]: 'KT',
  [keys.KT_OPENED_IN_ANOTHER_TAB]: 'KT opened in another tab',
  [keys.LABEL_DATA_RETENTION_DAYS]: 'Days for which data needs to be stored',
  [keys.LAST_ENGAGEMENT]: 'Last Engagement',
  [keys.LAUNCH_APP]: 'Launch App :',
  [keys.LEADS]: 'Leads',
  [keys.LEAVE]: 'Leave',
  [keys.LINEWORKS]: 'LINE WORKS',
  [keys.LOADING_CONFIG_EDITOR]: 'Loading Config Editor...',
  [keys.LOCATION]: 'Location',
  [keys.LOG_ACTIVITY]: 'Log Activity',
  [keys.LOGIN_WITH_PROVIDER]: 'Login with {{provider}}',
  [keys.LOGIN_WITH_OTHER_OPTIONS]: 'Login with other options',
  [keys.LOGOUT]: 'Logout',
  [keys.MANAGERS]: 'Managers',
  [keys.MANAGER_CHANGE_SUCCESS]: 'Manager changed successfully',
  [keys.MANAGER_DATA_VISIBILITY_DELAY_NOTE]:
    'Note: It could take some time for the new Manager to have visibility to all data belonging to their team members',
  [keys.MAX_SIZE_LIMIT_INFO]: 'Max size: {{size}}',
  [keys.MENU]: 'Menu',
  [keys.MESSAGE_SIGNING_SUCCESS_PROCEED]:
    'Thanks for signing. Click here to proceed.',
  [keys.METRICS]: 'Metrics',
  [keys.TRACKING]: 'Tracking',
  [keys.MOBILE]: 'Mobile',
  [keys.MODULE_INTEGRATION]: 'Module Integration',
  [keys.MORE]: 'More',
  [keys.MPIN_MISMATCH_ERROR]: 'MPIN and Confirm MPIN does not match',
  [keys.MPIN_DIGITS]: 'MPIN should be {{length}} digits',
  [keys.MY_DIRECT_REPORTS]: 'My Direct Reports',
  [keys.MY_PEERS]: 'My Peers',
  [keys.MY_MANAGER]: 'My Manager',
  [keys.NAVIGATE]: 'Navigate',
  [keys.NEW_PROJECT]: 'New Project',
  [keys.NEW_RELEASE]: 'New Release',
  [keys.NO]: 'No',
  [keys.NOT_SAVED]: 'Not Saved',
  [keys.NO_ACTIVITIES_FOUND]: 'No activities found',
  [keys.NO_DATA_FOUND_FOR_CARD]: 'No data found for {{cardName}}',
  [keys.NO_FIELDS_TO_DISPLAY_CAPITAL]: 'NO FIELDS TO DISPLAY',
  [keys.NO_HISTORY_FOUND]: 'No history found',
  [keys.NO_INPUTS_FOUND]: 'No Inputs Found',
  [keys.NO_PROFILE_DATA_FOUND]: 'No profile data found',
  [keys.NO_PROFILE_FIELDS_FOUND]: 'No profile fields found',
  [keys.NO_PROJECTS]: 'No Projects',
  [keys.NO_REFERRED_ENTITIES_FOUND]: 'No Referred entities found',
  [keys.NPM_REGISTRY]: 'Npm Registry',
  [keys.NPN_LOOKUP_TOOL]: 'NPN Lookup Tool',
  [keys.ONBOARDING_IN_PROGRESS_COUNT]: 'Onboarding in Progress ({{count}})',
  [keys.OTP_DIGITS]: 'OTP should be {{length}} digits',
  [keys.OUTGOING_EMAIL]: 'Outgoing Email',
  [keys.OUTLOOK_CALENDAR]: 'Outlook Calendar',
  [keys.PARTICIPANTS]: 'Participants',
  [keys.PASSWORD]: 'Password',
  [keys.PASSWORD_MISMATCH_ERROR]:
    'Password and Confirm Password does not match',
  [keys.PATCH_CURRENT]: 'Patch Current',
  [keys.PENDING_ACTIVITIES]: 'Pending Activities',
  [keys.PLACEHOLDER_SELECT_HINT]: 'Select {{hint}}',
  [keys.PLAYGROUND]: 'Playground',
  [keys.PORTAL_ID_CLIENT_ID]: 'Portal Id / Client Id',
  [keys.PRIMARY_PHONE_NUMBER]: 'Primary Phone Number',
  [keys.PRINT]: 'Print',
  [keys.PROJECT]: 'Project',
  [keys.PROJECT_PUBLISH_FILENAME_INFO]:
    'Project will be published as file with name {{projectCode}}',
  [keys.PROPERTY_TO_BIND]: 'Property to bind',
  [keys.PROPS_UI_ELEMENT_TYPE]: 'Props Ui {{elementType}}',
  [keys.PROVIDE_QUERY_FOR_TYPE_CASES]: 'Provide query for {{type}} cases',
  [keys.PUBLISH]: 'Publish',
  [keys.PUBLISH_UI]: 'Publish UI',
  [keys.PULL_REQUEST_CREATED]: 'Pull request created: {{prLink}}',
  [keys.QUERY]: 'Query',
  [keys.REASSIGN]: 'Reassign',
  [keys.RECENT]: 'Recent',
  [keys.RECOMMENDED_FOR_YOU]: 'Recommended for You',
  [keys.REFERRAL_SOURCE]: 'Referral Source',
  [keys.REFRESH]: 'Refresh',
  [keys.RELEASE_BRANCHES]: 'Release Branches',
  [keys.RESET]: 'Reset',
  [keys.RESET_CAPITAL]: 'RESET',
  [keys.RESET_PASSWORD_WITH_OTP_NOTE]:
    'Reset Password (Otp Will be sent to Phone number)',
  [keys.RESUME_SESSION]: 'Resume Session',
  [keys.RETRY]: 'Retry',
  [keys.RUN_PROJECT]: 'Run Project',
  [keys.SAMPLE_CONFIG_CAPITAL]: 'SAMPLE CONFIG',
  [keys.SAMPLE_CONFIGS]: 'SAMPLE CONFIGS',
  [keys.SAMPLE_FORM]: 'Sample Form',
  [keys.SAVE]: 'Save',
  [keys.SCHEDULE_ACTIVITY]: 'Schedule Activity',
  [keys.SCHEDULED_ACTIVITIES]: 'Scheduled Activities',
  [keys.SCHEDULE_FOLLOWUP]: 'Schedule Followup',
  [keys.SELECT]: 'Select',
  [keys.SELECT_ACTIVITY]: 'Select Activity',
  [keys.SELECT_ASSIGNEES]: 'Select Assignees',
  [keys.SELECT_PARTICIPANTS]: 'Select Participants',
  [keys.SELECT_THE_APP]: 'Select the app',
  [keys.SELECT_TYPE]: 'Select Type',
  [keys.SELECT_USER]: 'Select User',
  [keys.SELECT_VALUE]: 'Select value',
  [keys.SELF]: 'Self',
  [keys.SELFSERVE]: 'SelfServe',
  [keys.SEND_FOR_APPROVAL]: 'Send For Approval',
  [keys.SESSION_EXPIRED]: 'Session Expired!',
  [keys.SHARE]: 'Share',
  [keys.SHARE_VIA_GMAIL]: 'Share Via Gmail',
  [keys.SHARE_VIA_LINEWORKS]: 'Share Via LINEWORKS',
  [keys.SHARE_VIA_OUTLOOK]: 'Share Via Outlook',
  [keys.SHARE_VIA_SMS]: 'Share Via SMS',
  [keys.SHARE_VIA_VYMO]: 'Share Via Vymo',
  [keys.SHARE_VIA_WEBEX_MEETING]: 'Share Via Webex Meeting',
  [keys.SHARE_VIA_WHATSAPP]: 'Share Via WhatsApp',
  [keys.SHOW_LESS]: 'Show Less',
  [keys.SHOW_MORE]: 'Show More',
  [keys.START]: 'Start',
  [keys.STATIC]: 'Static',
  [keys.STEPPER_PLAYGROUND]: 'Stepper Playground',
  [keys.STEPPER_PLAYGROUND_CAPITAL]: 'STEPPER PLAYGROUND',
  [keys.STEPS]: 'Steps',
  [keys.STEP_CAPITAL]: 'STEP',
  [keys.STORYBOOK]: 'Storybook',
  [keys.STORYBOOK_OPENED_IN_ANOTHER_TAB]: 'Storybook opened in another tab',
  [keys.SWAGGER_API_DOCS]: 'API Docs (Swagger)',
  [keys.SUBMIT]: 'Submit',
  [keys.SUBMIT_CAPITAL]: 'SUBMIT',
  [keys.SUPERSET_DATA_NOT_FOUND]: 'SuperSet Data Not Found',
  [keys.SUPPORTED_FORMATS_INFO]: 'Supports - {{formats}} formats',
  [keys.TABLET]: 'Tablet',
  [keys.TARGET_COVERAGE]: 'Target Coverage',
  [keys.TEAM]: 'Team',
  [keys.TEAM_SELF]: 'Team/Self',
  [keys.TEMPLATE]: 'Template',
  [keys.TEMPLATE_CONFIG]: 'Template Config',
  [keys.TEMPLATE_CONFIG_CAPITAL]: 'TEMPLATE CONFIG',
  [keys.TEMPLATE_DRAFT_ALREADY_EXISTS]:
    'Template cannot be used as draft "{{draftVersion}}" exist',
  [keys.TEMPLATE_DRAFT_VERSION_EXISTS_ERROR]:
    'Template cannot be used as draft "{{draftVersion}}" exist. Either continue on that project or delete the same',
  [keys.TEMPLATE_LINKED]: 'Template linked',
  [keys.TEMPLATE_NOT_PUBLISHED]: 'Template not published',
  [keys.TOKENIZATION_ERROR]: 'Tokenization Error',
  [keys.TRANSLATE_SSUI_RULES_TO_FORMULA_CAPITAL]:
    'TRANSLATE SSUI RULES TO FORMULA',
  [keys.UI_BUILDER]: 'UI Builder',
  [keys.UNDEPLOYED]: 'Undeployed:',
  [keys.INVALIDATED]: 'Invalidated:',
  [keys.UNIQUE_CODE_UI_FILENAME_INFO]:
    'This will be the unique Code and will be the filename of the ui',
  [keys.UNLOCK_USER]: 'Unlock User',
  [keys.UNSAVED_CHANGES]: 'Unsaved Changes',
  [keys.UPDATE]: 'Update',
  [keys.UPDATE_CONFIG_CAPITAL]: 'UPDATE CONFIG',
  [keys.UPDATE_FORM]: 'Update Form',
  [keys.UPDATE_TASK]: 'Update Task',
  [keys.UPLOAD_FILE]: 'Upload File',
  [keys.USE]: 'Use',
  [keys.USER]: 'User',
  [keys.USERS_LIST]: 'Users List',
  [keys.USER_360_DATA_NOT_FOUND]: 'User 360 data not found',
  [keys.USER_DETAILS]: 'User Details',
  [keys.USER_DISABLE_SUCCESS]: 'User disabled successfully',
  [keys.USER_ENABLE_SUCCESS]: 'User enabled successfully',
  [keys.USER_PROFILE]: 'User Profile',
  [keys.USER_PROFILE_GROUPS_NOT_FOUND]: 'User Profile groups not found',
  [keys.USER_UNLOCK_SUCCESS]: 'User unlocked successfully',
  [keys.USER_UPDATE_SUCCESS]: 'User updated successfully',
  [keys.VALIDATE]: 'Validate',
  [keys.VALIDATIONS]: 'Validations',
  [keys.VALIDATION_SELECT_ALL_FIELDS]: 'Make sure to select all the fields',
  [keys.VIA_GMAIL]: 'Via Gmail',
  [keys.VIA_LINEWORKS]: 'Via LINEWORKS',
  [keys.VIA_OUTLOOK]: 'Via Outlook',
  [keys.VIA_SMS]: 'Via SMS',
  [keys.VIA_VYMO]: 'Via Vymo',
  [keys.VIA_WHATSAPP]: 'Via WhatsApp',
  [keys.VM_DETAILS]: 'VM Details',
  [keys.VM_STORAGE_DETAILS]: 'VM Storage Details',
  [keys.VYMO_COPILOT]: 'Vymo - Copilot',
  [keys.VYMO_FEATURE_BRANCH]: 'Vymo Feature Branch',
  [keys.VYMO_FORM]: 'Vymo Form',
  [keys.VYMO_REGISTRY_OPENED_IN_ANOTHER_TAB]:
    'Vymo Registry opened in another tab',
  [keys.VYMO_WEB]: 'Vymo Web',
  [keys.VIEW_ALL]: 'View All',
  [keys.VIEW_LEAD]: 'View Lead',
  [keys.WARNING_DELETE_CYPRESS_OLD_RECORDS]:
    'Caution, This will delete cypress records of days provided before the todays date',
  [keys.WARNING_DELETE_YARN_CACHE_DOCKER_VOLUMES]:
    'This will delete the yarn cache and docker ununsed volumes.',
  [keys.WARNING_UNSAVED_CHANGES_CONFIRM_LEAVE]:
    'You have unsaved changes. Are you sure you want to leave this page?',
  [keys.WEB]: 'Web',
  [keys.WEBEX_MEETING]: 'Webex Meeting',
  [keys.WEB_PLATFORM]: 'Web Platform',
  [keys.WEBPLATFORM_BRANCH]: 'WebPlatform Branch',
  [keys.WELCOME]: 'Welcome',
  [keys.WIKI_OPENED_IN_ANOTHER_TAB]: 'Wiki opened in another tab',
  [keys.YES]: 'Yes',
  [keys.ZOOM_MEETING]: 'Zoom Meeting',
  [keys.NO_COMPARISON_REPORT]: 'No Comparison Report Found',
  [keys.APPOINTMENT_LICENSE_NOTE]:
    'Please note that appointments will be created only for the selected states and LOAs.',
  [keys.LAST_MODIFIED]: 'Last Modified',
  [keys.PR]: 'Pull Request',
  [keys.INVALID_ACTION_REDIRECTION]:
    '{{redirectType}} is not a valid REDIRECT type.Please config for web separately',
  [keys.SELECT_APP]: 'Select App',
  [keys.SELECT_ENV]: 'Select Environment',
  [keys.SELECT_EVENT]: 'Select Event',
  [keys.SELECT_TIME_RANGE]: 'Select Time Range',
  [keys.TRACK_EVENTS]: 'Track Events',
  [keys.ADDRESS_FIELD_HEADER]: 'Add your address',
  [keys.ACTIVITIES]: 'Activities',
  [keys.COMPLETED_ACTIVITIES]: 'Completed Activities',
  [keys.PLANNED_ACTIVITIES]: 'Planned Activities',
  [keys.IMPERSONATE]: 'Impersonate',
  [keys.NO_ROWS_FOUND]: 'No Rows Found',
  [keys.GET_HELP]: 'Get Help',
  [keys.SCREEN_RECORDING_STARTED]: 'Screen recording started',
  [keys.TODAY_AT]: 'Today At',
  [keys.YESTERDAY_AT]: 'Yesterday At',
  [keys.AT]: 'At',
  [keys.GOOGLE]: 'Google',
  [keys.ZOOM]: 'Zoom',
  [keys.WEBEX]: 'Webex',
  [keys.OFFICE_365]: 'Office 365',
  [keys.CONFIRMATION]: 'Confirmation',
  [keys.ASK_COPILOT]: 'Ask Copilot',
  [keys.HEY]: '👋',
  [keys.HEY_STRING]: 'Hey',
  [keys.WELCOME_TEXT1]:
    'Check the Activities Timeline section to log activities',
  [keys.WELCOME_TEXT3_NEW_A]: `Did you know there are additional dashboards within the 'Reports' section.`,
  [keys.WELCOME_TEXT3_NEW_B]: `did you know there are additional dashboards within the 'Dashboards' section?`,
  [keys.CLICK_LINK]: 'Click Link',
  [keys.HEY_TEXT]: ' ',
  [keys.AUTOMATED_ACTIVITIES]: 'Automated Activities',
  [keys.SELECT_LOCATION]: 'Select Location',
  [keys.SELECT_PHONE_NUMBER]: 'Select Phone Number',
  [keys.ACTIVITY]: 'Activity',
  [keys.CREATE]: 'Create',
  [keys.CREATE_ACTIVITY]: 'Create Activity',
  [keys.CREATE_PAYMENT]: 'Create Payment',
  [keys.PAYMENT]: 'Payment',
  [keys.ACTIVITY_TYPE]: 'Activity Type',
  [keys.WORKFLOW_TYPE]: 'Workflow Type',
  [keys.NAME]: 'Name',
  [keys.RELATED_QUESTIONS]: 'Related Questions',
  [keys.DOWNLOAD_LIST]: 'Download List',
  [keys.ERROR_DOWNLOADING_LIST]: 'Error while downloading list',
  [keys.JOB_TYPE]: 'Job Type',
  [keys.STATUS]: 'Status',
  [keys.RECEIVED_DATE]: 'Received Date',
  [keys.AVAILABLE_TILL]: 'Available Till',
  [keys.PROGRESS]: 'Progress',
  [keys.JOB_DETAILS]: 'Job Details',
  [keys.DOWNLOAD_USERS]: 'Download Users',
  [keys.DOWNLOAD_LINK_IN_PROGRESS]:
    'Please wait while your download link is getting ready',
  [keys.DOWNLOAD_READY]: 'Your download is ready',
  [keys.COMPLETED]: 'Completed',
  [keys.DOWNLOAD_JOB_CANCELLED]: 'Download job cancelled on request',
  [keys.RE_REQUEST_DOWNLOAD]: 'Re-request Download',
  [keys.DOWNLOAD_REPORT]: 'Download Report',
  [keys.CANCEL_DOWNLOAD]: 'Cancel Download',
  [keys.ERROR_DOWNLOADING_FILE]: 'Error downloading file',
  [keys.WORKFLOW_DOWNLOADS]: 'Workflow Downloads',
  [keys.CALL_INITIATED_MESSAGE]: 'Thank you, your call is being placed',
  [keys.ERROR_CANCELLING_DOWNLOAD]: 'Error cancelling download',
  [keys.CREATE_NEW_RECORD]: 'Create New Record',
  [keys.CREATE_NEW_USER]: 'Create New User',
  [keys.RESET_ALL]: 'Reset All',
  [keys.MANAGE_COLUMNS]: 'Column Settings',
  [keys.MANAGE_COLUMNS_DESC]: 'Rearrange, Add or Hide columns to the table',
  [keys.YOU_HAVE]: 'You have',
  [keys.PENDING_ACTIVITIES_INFO]: 'pending activities left',
  [keys.NO_NAME]: 'No name',
  [keys.NO_ADDRESS_FOUND]: 'No address provided',
  [keys.CONFIRM]: 'Confirm',
  [keys.DISCONNECT_CONFIRMATION]: 'Are you sure you want to disconnect?',
  [keys.NO_MATCH_FOUND]: `We couldn't find a match`,
  [keys.TRY_DIFFERENT_KEYWORD]: `Please check your keywords or try different terms to help us find what you're looking for`,
  [keys.SEARCH_PLACEHOLDER]:
    'You can search for leads, partners, phone number and email Id..',
  [keys.ACTIVITY_CARD_PLACEHOLDER]: 'Select an activity to view details',
  [keys.ACTIVITY_CARD_LOADING]: 'Loading activity data',
  [keys.NO_FILTER_FIELDS_FOUNDS]: 'No filter fields found',
  [keys.SOMETHING_WENT_WRONG]: 'Something went wrong',
  [keys.TRAILS]: 'Trails',
  [keys.ADD_A_TRAIL]: 'Add a Trail',
  [keys.AUDIT]: 'Audit',
  [keys.BORROWERS]: 'Borrowers',
  [keys.TRAIL_ADDED_SUCCESSFULLY]: 'Trail has been added successfully',
  [keys.END_TIME_MUST_BE_GREATER_THAN_START_TIME]:
    'End time must be greater than start time',
  [keys.VIEW_ON_GOOGLE_MAPS]: 'View on Google Maps',
  [keys.NO_POLICY_DETAILS_FOUND]: 'No policy details found',
  [keys.POLICY_DETAILS]: 'Policy Details',
  [keys.DETAIL]: 'Detail',
  [keys.COLLECT_PAYMENT]: 'Collect Payment',
  [keys.SIGNIN_INTO_VYMO]: 'Please wait, Signing you in to VYMO',
  [keys.BACK_TO_LOGIN]: 'Go Back to Login',
  [keys.DELETE]: 'Delete',
  [keys.REACTIVATE]: 'Reactivate',
  [keys.SEND_MESSAGE]: 'Send Message',
  [keys.INITIATE_AI_CALL]: 'Initiate AI Call',
  [keys.ENGAGEMENT]: 'Engagement',
  [keys.UI_FIELDS]: 'UI Fields',
  [keys.ENGAGEMENT_DETAILS]: 'Engagement Details',
  [keys.ENGAGEMENT_OUTCOME]: 'Engagement Outcome',
  [keys.AMOUNT]: 'Amount',
  [keys.OPEN]: 'Open',
  [keys.UPDATED]: 'Updated',
  [keys.PAYMENT_PENDING]: 'Payment Pending',
  [keys.PAYMENT_COMPLETED]: 'Payment Completed',
  [keys.NO_RESULTS_TO_SHOW]: 'No Results to Show',
  [keys.FACING_ERROR]: 'Facing Error',
  [keys.SERVER_ERROR_MESSAGE]:
    'The server encountered an error and was unable to complete your request.',
  [keys.NO_DATA_TO_SHOW]: 'Looks like there is no data in the {{tab}} to show',
  [keys.KEY_METRICS]: 'Key Metrics',
  [keys.MIN_CHARS_TO_SEE_RESULTS]:
    'Please type a minimum of 3 characters to see results',
  [keys.RECENT_SEARCHES]: 'Recent Searches',
  [keys.RESULT_WILL_POPULATE_HERE]: 'Your recent searches will populate here',
  [keys.PLEASE_WAIT_WHILE_WE_COMPLETE_YOUR_QUERY]:
    'Please wait while we complete your query',
  [keys.SEARCH_RESULTS]: 'Search Results',
  [keys.IN]: 'in',
  [keys.PERFORMANCE]: 'Performance',
  [keys.DASHBOARD]: 'Dashboard',
  [keys.NO_MODULE_FOUND]: 'No module found',
  [keys.LEADERBOARD]: 'Leaderboard',
  [keys.TEAM_BREAKDOWN]: 'Team Breakdown',
  [keys.PERFORMANCE_OVERVIEW]: 'Performance Overview',
  [keys.HISTORIC_GRAPH]: 'Historic Graph',
  [keys.DAYS]: 'Days',
  [keys.MONTHS]: 'Months',
  [keys.GOAL]: 'Goal',
  [keys.ACHIEVEMENT]: 'Achievement',
  [keys.TARGET]: 'Target',
  [keys.EXPECTED_TARGET]: 'Expected target',
  [keys.SHORTFALL]: 'Shortfall',
  [keys.PEOPLE_ACHIEVED]: 'People Achieved',
  [keys.LAST_UPDATED_ON]: 'Last updated on {{date}}',
  [keys.PERFORMANCE_SNAPSHOT]: 'Performance Snapshot',
  [keys.FAILED_TO_LOAD_PERFORMANCE_METRICS_DATA]:
    'Failed to load performance metrics data',
  [keys.RANK]: 'Rank',
  [keys.DESCRIPTION]: 'Description',
  [keys.POINTS]: 'Points',
  [keys.MY_POINTS]: 'My Points',
  [keys.MY_RANKING]: 'My Ranking',
  [keys.TOP_SCORERS]: 'Top Scorers',
  [keys.DASH]: '-',
  [keys.BULK_REASSIGN]: 'Bulk Reassign',
  [keys.UPLOAD]: 'Upload',
  [keys.MISSING_TEMPLATE_DOWNLOAD_LINK]: 'Missing template download link',
  [keys.VIEW_PREVIOUS_METRICS]: 'View Previous Metrics',
  [keys.VIEW_NEXT_METRICS]: 'View Next Metrics',
};
